import type { UserJobApplicationCv } from '@xing-com/crate-common-graphql-types';

export const getSortedCvs = (
  userRecentCvs?: (UserJobApplicationCv | null)[] | null
): UserJobApplicationCv[] => {
  return (
    userRecentCvs
      ?.filter(
        (item: UserJobApplicationCv | null): item is UserJobApplicationCv =>
          item !== null
      )
      .sort(
        (a, b) =>
          new Date(b.lastUsedAt).getTime() - new Date(a.lastUsedAt).getTime()
      ) ?? []
  );
};
